import { Box, Center, CenterProps, Flex, Heading, HStack, Image, Link, Text } from '@chakra-ui/react';
import content from 'assets/images/content.svg';
import { format, setDefaultOptions } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useFormContext } from 'react-hook-form';

setDefaultOptions({ locale: ptBR });

type PlaceholderProps = CenterProps & {
  text: string;
  isVisible: boolean;
}

function Placeholder({ children, isVisible, text, ...props }: PlaceholderProps) {
  if (isVisible)
    return children;
  return (
    <Center
      padding="4px 8px"
      justifyContent="center"
      alignItems="center"
      borderRadius="6px"
      border="1px solid #E1E4EA"
      bgColor="white"
      {...props}
    >
      {text}
    </Center>
  );
}

export default function TemplateEmailPreview() {
  const { watch } = useFormContext();
  const [name, logo, color, colorTitle, footerDescription, footerLinkedInUrl, footerSiteUrl, footerEmail, footerImage] = watch(['name', 'logo', 'color', 'colorTitle', 'footerDescription', 'footerLinkedInUrl', 'footerSiteUrl', 'footerEmail', 'footerImage']);

  return (
    <Box 
      w="full"
      maxW="525px"
      minW="480px"
      p="20px"
      bgColor="rgba(226, 228, 233, 0.50)"
      
      sx={{
        '.content': {
          p: '35px 30px'
        }
      }}
    >
      <Box
        bgColor="white"
        borderRadius="20px"
        border="solid 1px rgba(0, 0, 0, 0.20)"
        overflow="hidden"
      >
        <Box
          w="full"
          h="21px"
          bgColor={color}
        />

        <Box
          className="content"
          pb="48px"
          borderBottom="solid 1px rgba(0, 0, 0, 0.20)"
        >
          <Flex
            justifyContent="space-between"
          >
            <Box>
              <Text
                color="#525753"
                fontSize="14px"
              >
                {format(new Date(), "cccc, dd 'de' MMMM 'de' yyyy")}
              </Text>

              <Placeholder 
                isVisible={!!name} 
                text="Nome do modelo"
                mt="15px"
              >
                <Heading 
                  as="h1" 
                  size="h1" 
                  lineHeight="110%"
                  fontSize="25px" 
                  textTransform="uppercase"
                  mt="13px"
                  color={colorTitle}
                >
                  {name}
                </Heading>
              </Placeholder>
            </Box>

            <Placeholder 
              isVisible={!!logo} 
              text="Logo do modelo"
              flexShrink={0}
              alignSelf="flex-start"
            >
              <Image maxW="180px" src={logo} alignSelf="flex-start" />
            </Placeholder>
            
          </Flex>
        </Box>

        <Box p="120px 35px 150px">
          <Center
            flexDir="column"
          >
            <Image src={content} />
            <Text
              w="250px"
              mt="25px"
              textAlign="center"
            >
              Aqui será inserido o <strong>conteúdo</strong> do seu
              disparo com os respectivos campos
            </Text>
          </Center>
        </Box>
      </Box>

      <Box
        p="0 35px 50px"
        sx={{
          span: {
            color: '#828282',
            lineHeight: '157.143%'
          }
        }}
      >
        <Box
          sx={{
            p: {
              mb: '15px'
            }
          }}
        >

          {/* <Text as="span">
            <strong>PATRI Políticas Públicas & Public Affairs Ltda.</strong><br />
            SAF Sul Quadra 02, Bloco D, Edifício Via Esplanada, Salas 103 a 106 - Brasília, DF<br />
            CEP: 70070 600 Fone: (61) 3327 2606<br />
            <strong>Brasília&nbsp;&nbsp;&nbsp;&nbsp;São Paulo&nbsp;&nbsp;&nbsp;&nbsp;Belo Horizonte</strong>
          </Text>

          <Text as="span">
            <strong>PATRI Public Policy & Public Affairs Inc.</strong><br />
            1101 17th Street NW, Suite 610 - Washington, DC 20036<br />
            Fone: +1 202 822 6420
          </Text> */}
          <Box 
            whiteSpace="pre-wrap"
            mt="45px"
            dangerouslySetInnerHTML={{
              __html: footerDescription
            }}
          />
        </Box>

        <Placeholder 
          isVisible={!!footerImage} 
          maxW="158px"
          mt="45px" 
          text="Imagem do rodapé"
        >
          <Image maxW="160px" mt="45px" src={footerImage} />  
        </Placeholder>
        
        <Flex 
          justifyContent="space-between"
          mt="70px"
        >
          <Text as="span">
            © 2024 Patri Políticas Públicas<br /> 
            Todos os direitos reservados
          </Text>
          
          <HStack 
            spacing="10px"
            sx={{
              img: {
                h: '40px',
                w: '40px'
              }
            }}
          >
          {!!footerSiteUrl?.trim() && (
            <Link
              target="_blank"
              href={footerSiteUrl}
            >
              <Image src="/email/icon-website.png" alt="Website"  />
            </Link>
          )}

          {!!footerEmail?.trim() && (
            <Link
              target="_blank"
              href={footerEmail}
            >
              <Image src="/email/icon-email.png" alt="E-mail"  />
            </Link>
          )}

          {!!footerLinkedInUrl?.trim() && (
            <Link
              target="_blank"
              href={footerLinkedInUrl}
            >
              <Image src="/email/icon-linkedin.png" alt="LinkedIn"  />
            </Link>
          )}
          </HStack>
        </Flex>
      </Box>
    </Box>
  )
}
